// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardContextMenu {
  background-color: white;
  border: 2px solid #000;
  border-radius: 5px; }
  .CardContextMenu .menu-action {
    border-bottom: 1px dashed;
    margin: 0;
    padding: 0.3rem 1rem;
    width: 100%;
    cursor: pointer;
    font-family: inherit;
    font-size: 1rem; }
    .CardContextMenu .menu-action.red:hover {
      background-color: rgba(255, 0, 0, 0.7); }
    .CardContextMenu .menu-action.blue:hover {
      background-color: rgba(0, 149, 255, 0.7); }
    .CardContextMenu .menu-action.green:hover {
      background-color: rgba(0, 177, 6, 0.7); }
    .CardContextMenu .menu-action.neutral:hover {
      background-color: rgba(255, 212, 0, 0.7); }
    .CardContextMenu .menu-action.black:hover {
      background-color: rgba(0, 0, 0, 0.7); }
    .CardContextMenu .menu-action:last-of-type {
      border-bottom: none; }
    .CardContextMenu .menu-action:not(.neutral):hover {
      color: white;
      cursor: pointer;
      border-color: black; }
`, "",{"version":3,"sources":["webpack://./src/components/CardContextMenu.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAUA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB,EAAA;EAHpB;IAMI,yBAAyB;IACzB,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,eAAe,EAAA;IAlBf;MACE,sCCFqB,EAAA;IDCvB;MACE,wCCHwB,EAAA;IDE1B;MACE,sCCAuB,EAAA;IDDzB;MACE,wCCD0B,EAAA;IDA5B;MACE,oCCYW,EAAA;IDPjB;MAgBM,mBAAmB,EAAA;IAhBzB;MAoBM,YAAY;MACZ,eAAe;MACf,mBAAmB,EAAA","sourcesContent":["@import \"./../style/colors\";\n\n@mixin option-color-hover {\n  @each $name, $hex in $cardColors {\n    &.#{$name}:hover {\n      background-color: rgba($hex, 0.7);\n    }\n  }\n}\n\n.CardContextMenu {\n  background-color: white;\n  border: 2px solid #000;\n  border-radius: 5px;\n\n  .menu-action {\n    border-bottom: 1px dashed;\n    margin: 0;\n    padding: 0.3rem 1rem;\n    width: 100%;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 1rem;\n    @include option-color-hover();\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n\n    &:not(.neutral):hover {\n      color: white;\n      cursor: pointer;\n      border-color: black;\n    }\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
